<script>
    export let text
</script>

<style>
    .day-item {
        display: inline-block;
        border-radius: 9px;
        padding: 1px 8px 0px;
        font-size: 11px;
        font-weight: 600;
        line-height: 14px;
        cursor: default;
        background-color: #859db3;
        color: #fff;
        margin: 10px 0 10px 20px;
    }
</style>

<div class="day-item">{text}</div>